import React from 'react'

function Header() {
    return (
        <div className="header">
            <div className="blur">
            <h1 className="header-text">
            Our Mission is Simple: To help you search, apply and secure jobs that help you advance your career without stress
            </h1>
            </div>
        </div>
    )
}

export default Header